import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NRegionApi = global.NRegionApi

/**
 * 区域相关接口
 */
class RegionApi extends Http {
  /**
   * 获取全国城市列表
   * @returns
   */
  public async getCityMapping() {
    return await super.request<NRegionApi.CityMappingResp>({
      url: '/crossbowSystem/getCityMapping',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: null
    })
  }
}

export default RegionApi
